import { render } from "./ConfirmacionEnvioEmails.vue?vue&type=template&id=2ca4ba84&scoped=true"
import script from "./ConfirmacionEnvioEmails.vue?vue&type=script&lang=js"
export * from "./ConfirmacionEnvioEmails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca4ba84"]])

export default __exports__